module.exports = __webpack_public_path__ + "static/media/bundesverband_startups_deutschland_logo.2ca5e89c.png";